import funcion from "./funcion/funcion";

const paginaOficial = {
  funcion: funcion
}

export default paginaOficial



//////////////////
// WEBPACK FOOTER
// ./static/js/api/PaginaOficial/paginaoficialapi.js
// module id = null
// module chunks = 